import React, { useState } from "react";
import { View, Text, Button, TextInput, StyleSheet, Dimensions, Picker, Modal} from "react-native";
import axios from "axios";
import UserPersistence from "../../singletons/UserPersistence";
import config from "../../../config.json";
import states from "./states.json";
import months from "./months.json";
import years from "./years.json";


const {width, height} = Dimensions.get('window')
const CreditCardModal = ({selectedCard, isVisible, formTitile, contractId, allCardNumber, updateAllCreditCardInfo, updateModalVisible}) => {

    const [modalVisible, setModalVisible] = useState(isVisible);

    const [cardName, setCardName] = useState(selectedCard? selectedCard.cardHolderName: '');
    const [cardNumber, setCardNumber] = useState(selectedCard? selectedCard.cardNumber: '');
    const [cardCode, setCardCode] = useState(selectedCard? selectedCard.cardCode: '');
    const [cardExpMonth, setCardExpMonth] = useState(selectedCard? selectedCard.cardExpMonth: '');
    const [cardExpYear, setCardExpYear] = useState(selectedCard? selectedCard.cardExpYear: '');
    const [billingName, setBillingName] = useState(selectedCard? selectedCard.billingName: '');
    const [billingAddress, setBillAddress] = useState(selectedCard? selectedCard.billingAddress: '');
    const [billingCity, setBillingCity] = useState(selectedCard? selectedCard.billingCity: '');
    const [billingState, setBillingState] = useState(selectedCard? selectedCard.billingState: '');
    const [billingZip, setBillingZip] = useState(selectedCard? selectedCard.billingZip: '');

    const handleCloseModal = () => {
        updateModalVisible();
        setModalVisible(false);
    }

    const isValidCardCode = (CVV_Number) => {
        let regex = new RegExp(/^[0-9]{3,4}$/);
        if (CVV_Number == null) {
            return false;
        }
     
        if (regex.test(CVV_Number)) {
            return true;
        }
        else {
            return false;
        }
    }

    // const isValidMonth = (Month_Str) => {
    //     let regex = new RegExp(/^(0[1-9]|1[012])$/)

    //     return regex.test(Month_Str);
    // }

    // const isValidYear = (Year_Str) => {
    //     //YEAR for 1900-2099
    //     let regex = new RegExp(/^(19|20)\d{2}$/)

    //     if(Year_Str==null){
    //         return false;
    //     }

    //     if(regex.test(Year_Str)){
    //         return true;
    //     }else{
    //         return false;
    //     }

    // }

    // const isValidState = (US_State)=>{
    //     let regex = new RegExp(/(A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])/);
    //     return regex.test(US_State);
    // }

    const isValidZip = (US_Zip) => {
        let regex = new RegExp(/^[0-9]{5}(?:-[0-9]{4})?$/);
        return regex.test(US_Zip);
    }
    //检查表单字段是否符合要求
    const checkValidation = () => {
        const cardNameValid = cardName.length>0 && cardName.length < 20;
        const cardNumberValid = cardNumber.length <= 19 && cardNumber.length>=8;
        const cardCodeValid = isValidCardCode(cardCode);
        // const cardExpMonthValid = isValidMonth(cardExpMonth) 
        // const cardExpYearValid = isValidYear(cardExpYear) 
        const billingNameValid = billingName.length>0 && billingName.length < 20;
        const billingAddressValid = billingAddress.length < 100 && billingAddress.length > 0;
        const billingCityValid = billingCity.length< 50 && billingCity.length>0 ;
        // const billingStateValid = isValidState(billingState);
        const billingZipValid = isValidZip(billingZip);
        
        if (!cardNameValid) {
            alert("Invalid card holder name");
            return false;
        }
        
        if (!cardNumberValid) {
            alert("Invalid card number");
            return false;
        }
    
        if (!cardCodeValid) {
            alert("Invalid card security code");
            return false;
        }
    
        if (!billingNameValid) {
            alert("Invalid billing name");
            return false;
        }
    
        if (!billingAddressValid) {
            alert("Invalid billing address");
            return false;
        }
    
        if (!billingCityValid) {
            alert("Invalid billing city");
            return false;
        }
    
        if (!billingZipValid) {
            alert("Invalid billing zip");
            return false;
        }
    
        return true;
    }

    const checkDuplicateCardNumber = (existingCardNumberArr, addingCardNumber) => {
        const count = existingCardNumberArr.length;  
        console.log(`cardnumber is ${existingCardNumberArr}, total count is ${count}`);  
        if(count === 0) return true;
        const isDuplication = existingCardNumberArr.some((cardNumber)=>(cardNumber===addingCardNumber));
        return !isDuplication;
    }

    const handleSubmit = async () => {
        console.log(`current user's contractId is ${contractId}`);
        if(selectedCard){
            //edit modal submit
            const isPass = checkValidation();
            console.log('选中的卡的id是: '+ selectedCard.id);
            if(isPass){
                await updateContractById();
                await updateCCHistoryById();
                setModalVisible(!modalVisible);
                updateModalVisible();
                updateAllCreditCardInfo();
                console.log('updateAllCreditCardInfo is called')
            }
        }else if(!selectedCard){
            //Add modal submit
            const isPass = checkValidation();
            console.log(`选中的卡的id是: '${selectedCard? selectedCard.id : '没有选中的卡'}`);
            if(isPass){
                const noDuplication = checkDuplicateCardNumber(allCardNumber, cardNumber);
                if(noDuplication){
                    await updateContractById();
                    await insertCCHistory();
                    setModalVisible(!modalVisible);
                    updateModalVisible();
                    updateAllCreditCardInfo();
                    console.log('updateAllCreditCardInfo is called')
                }else{
                    alert('Adding failed, your card exits!');
                }
            }
        }
    }
    //根据contractId更新contract表
    const updateContractById = async() => {
        try{
            const getAllParams = {
                contractId: parseInt(contractId),
                cardHolderName: cardName,
                cardNumber: cardNumber,
                cardCode: cardCode,
                cardExpMonth: cardExpMonth,
                cardExpYear: cardExpYear,
                billingName: billingName,
                billingAddress: billingAddress,
                billingCity: billingCity,
                billingState: billingState,
                billingZip: billingZip,
            };
            const res = await axios.
                post(config.user.protocol + config.user.address + ':' + config.user.port + '/updateContractByContractId', {},
                    {
                        params: {data:JSON.stringify(getAllParams)}
                    },
                    {
                        headers: { 
                        "Content-Type":   "application/json",
                        "X-Auth-User":    UserPersistence.getInstance().userId,
                        "X-Auth-Token":   UserPersistence.getInstance().userAccessToken,
                        "access-control-allow-origin" : "*",
                        }
                    }
                )

            console.log(res.data)
        }
        catch(error){
            console.log(error);
        }
    }


    const updateCCHistoryById = async()=>{
        try{
            const getAllParams = {
                contractId: selectedCard.id,
                cardHolderName: cardName,
                cardNumber: cardNumber,
                cardCode: cardCode,
                cardExpMonth: cardExpMonth,
                cardExpYear: cardExpYear,
                billingName: billingName,
                billingAddress: billingAddress,
                billingCity: billingCity,
                billingState: billingState,
                billingZip: billingZip,
            };
            const res = await axios.
                post(config.user.protocol + config.user.address + ':' + config.user.port + '/updateCCHistoryById', {},
                    {
                        params: {data:JSON.stringify(getAllParams)}
                    },
                    {
                        headers: { 
                        "Content-Type":   "application/json",
                        "X-Auth-User":    UserPersistence.getInstance().userId,
                        "X-Auth-Token":   UserPersistence.getInstance().userAccessToken,
                        "access-control-allow-origin" : "*",
                        }
                    }
                )

            alert(`${res.data}`);
        }
        catch(error){
            console.log(error);
        }
    }

    const insertCCHistory = async() =>{
        try{
            const getAllParams = {
                userName: UserPersistence.getInstance().userName,
                cardHolderName: cardName,
                cardNumber: cardNumber,
                cardCode: cardCode,
                cardExpMonth: cardExpMonth,
                cardExpYear: cardExpYear,
                billingName: billingName,
                billingAddress: billingAddress,
                billingCity: billingCity,
                billingState: billingState,
                billingZip: billingZip,
            };
            const res = await axios.
                post(config.user.protocol + config.user.address + ':' + config.user.port + '/insertCCHistory', {},
                    {
                        params: {data:JSON.stringify(getAllParams)}
                    },
                    {
                        headers: { 
                        "Content-Type":   "application/json",
                        "X-Auth-User":    UserPersistence.getInstance().userId,
                        "X-Auth-Token":   UserPersistence.getInstance().userAccessToken,
                        "access-control-allow-origin" : "*",
                        }
                    }
                )

            alert(`${res.data}`);
        }
        catch(error){
            console.log(error);
        }
    }


    return (
        <View>
            <Modal
                // style={{
                //     overlay: {
                //         position: 'fixed',
                //         top: height*0.15,
                //         left: width>640? width*0.3 : width*0.2 ,
                //         right: width>640? width*0.3 : width*0.2,
                //         bottom: height*0.15,
                //         width: width>640? width*0.4 : width*0.6,
                //         height: height*0.7,
                //         backgroundColor: 'rgba(255, 255, 255, 0.75)'
                //     },
                //     content: {
                //         position: 'absolute',
                //         top: '10px',
                //         left: '10px',
                //         right: '10px',
                //         bottom: '10px',
                //         border: '1px solid #ccc',
                //         background: '#fff',
                //         overflow: 'auto',
                //         WebkitOverflowScrolling: 'touch',
                //         borderRadius: '4px',
                //         outline: 'none',
                //         padding: '20px'
                //     }
                // }}
                visible={modalVisible}
            >
                <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                        <Text style={styles.text}>{formTitile}</Text>
                        <TextInput 
                            style={styles.textInput} 
                            placeholder="Card Holdler Name" 
                            value={cardName}
                            onChangeText={(text) => setCardName(text)}
                        />
                        <TextInput 
                            style={styles.textInput} 
                            placeholder="Credit Card"
                            value={cardNumber}
                            onChangeText={(text) => setCardNumber(text)}

                        />
                        <TextInput 
                            style={styles.textInput} 
                            placeholder="Security Code"
                            value={cardCode}
                            onChangeText={(text) => setCardCode(text)}
                        />
                        <Text style={{ fontSize: 14, fontWeight: '300', marginBottom: 10, color: 'grey' }}>select expired month</Text>
                        <Picker
                            selectedValue={cardExpMonth}
                            onValueChange={(month)=> setCardExpMonth(month)}
                            style={[styles.textInput]}
                        >
                            {months.map((month)=>(
                                <Picker.Item
                                    key={month.name}
                                    label={month.abbreviation}
                                    value={month.number}
                                />
                            ))}
                        </Picker>
                        <Text style={{ fontSize: 14, fontWeight: '300', marginBottom: 10, color: 'grey' }}>select expired year</Text>
                        <Picker
                            selectedValue={cardExpYear}
                            onValueChange={(year)=> setCardExpYear(year)}
                            style={[styles.textInput]}
                        >
                            {years.map((year)=>(
                                <Picker.Item
                                    key={year.year}
                                    label={year.year}
                                    value={year.year}
                                />
                            ))}
                        </Picker>
                        <TextInput 
                            style={styles.textInput} 
                            placeholder="Billing Name"
                            value={billingName}
                            onChangeText={(text) => setBillingName(text)}
                        />
                        <TextInput 
                            style={styles.textInput} 
                            placeholder="Billing Street"
                            value={billingAddress}
                            onChangeText={(text) => setBillAddress(text)}
                        />
                        <TextInput 
                            style={styles.textInput} 
                            placeholder="Billing City"
                            value={billingCity}
                            onChangeText={(text) => setBillingCity(text)}
                        />
                        <Picker
                            selectedValue={billingState}
                            onValueChange={(state)=> setBillingState(state)}
                            style={[styles.textInput]}
                        >
                            {states.map((state)=>(
                                <Picker.Item
                                    key={state.name}
                                    label={state.abbreviation}
                                    value={state.abbreviation}
                                />
                            ))}
                        </Picker>
                        <TextInput 
                            style={styles.textInput} 
                            placeholder="Billing Zipcode"
                            value={billingZip}
                            onChangeText={(text) => setBillingZip(text)}
                        />

                        <View style={styles.buttonRowContainer}>
                            <Button title='return' style={styles.button} onPress={handleCloseModal} />
                            <Button title='submit' style={styles.button} onPress={handleSubmit} />
                        </View>
                    </View>
                </View>

            </Modal>
        </View>
    )
}

const styles = StyleSheet.create({

    modalContainer:{
        position: 'fixed',
        top: height*0.1,
        left: width>640? width*0.35 : width*0.25 ,
        right: width>640? width*0.35 : width*0.25,
        bottom: height*0.1,
        width: width>640? width*0.3 : width*0.5,
        height: height*0.8,
        border: '1px solid #ccc',
 
        WebkitOverflowScrolling: 'touch',
        borderRadius: '4px',
 
        padding: '20px',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },

    modalContent: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },

    text: {
        width: '100%',
        marginBottom: 10,
        fontWeight: '600',
        textAlign: 'center',
    },

    textInput: {
        width: '100%',
        marginBottom: 10,
        padding: 10,
        borderWidth: 1,
        borderColor: '#ccc',
        borderRadius: 5,
    },
    buttonRowContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 20,
        width: '100%',
      },
    button: {
        flex: 1,
        marginHorizontal: 5,
    },

})


export default CreditCardModal;